<!-- <app-type-adresse-complete-obligatoire id="step1" [uid]="getUid()" [parentForm]="parentForm" [disabled]="disabled"
	[organisme]="divers.organisme" [formName]="formName">
</app-type-adresse-complete-obligatoire> -->

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
[value]="divers?.organisme?.classificationOrganisme" 
[label]="step3.getclassificationorganisme"
[type]="'select'"
[autoCompleteType]="'CLASSIFICATIONORGANISME'"
[autoCompleteTypeIndex]="0" [rule]="'pattern_26'"
[optionsWithCode]="optionsSelect"
[typeSelect]="optionsSelectType"
[name]="getUid()+'_SepAtt_classificationOrganisme'">
</app-form-input>

<span class="d-block">{{ step3.getspan2 | translate }}</span>

<app-type-pers id="step1" [uid]="getUid()" [parentForm]="parentForm" [disabled]="disabled"
	[correspondantPRM]="divers?.organisme?.correspondantPRM" >
</app-type-pers>

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
[value]="divers.organisme?.acheteurPublic" 
[label]="step3.getacheteurpublic"
[type]="'text'"
[rule]="'pattern_31|minSize_1|maxSize_1000'"
[name]="getUid()+'_SepAtt_acheteurPublic'">
</app-form-input>

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
[value]="divers?.organisme?.adr?.pays" 
[label]="step3.getpaysnonfrance"
[type]="'text'"
[rule]="'pattern_28|maxSize_200'"
[name]="getUid()+'_SepAtt_pays'"
[errorMessage]="{'pattern' : 'ctr_48'}">
</app-form-input>

<app-type-coord  [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
[coord]="divers?.organisme?.coord"></app-type-coord>



<!-- URL profil acheteur -->

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
[value]="divers?.organisme?.urlProfilAcheteur" 
[label]="step3.geturlprofilacheteur"
[type]="'text'"
[rule]="'pattern_28|maxSize_200'"
[name]="getUid()+'_SepAtt_urlProfilAcheteur'"
[errorMessage]="{'pattern' : 'ctr_568'}">
</app-form-input>
